import type { ProductVariant } from '@grafikr/shopify-typescript/type/liquid/ProductVariant';
import { Component } from '@grafikr/components';

import getProductData from 'utils/get-product-data';
import { assertNonNullish, NonNullish } from 'utils/nullish-check';

export default Component((node, { onMounted, dispatchEvent }) => {
  const { index, value } = node.dataset;

  const classes = {
    available: 'is-available',
  };

  const productContainer = NonNullish(node.closest<HTMLElement>('.product'));
  const { product: data } = getProductData(productContainer);

  assertNonNullish(data);

  const allOptions = productContainer.querySelectorAll<HTMLButtonElement>(
    `[data-component="${node.dataset.component}"]`,
  );

  const allOtherIndexOptions = Array.from(allOptions).filter(
    (option) => option.dataset.index !== index,
  );

  const getAllRelatedVariants = data.variants.filter(
    (variant) => variant.options[parseInt(NonNullish(index), 10)] === value,
  );

  const updateOption = (variant: ProductVariant) => {
    const relatedOption = allOtherIndexOptions.find(
      (option) =>
        option.dataset.value === variant.options[parseInt(NonNullish(option.dataset.index), 10)],
    );

    if (!relatedOption) {
      return;
    }

    relatedOption.classList.toggle(classes.available, variant.available);
  };

  const init = () => {
    // Abort and handle in liquid
    if (data.options.length === 1) {
      return;
    }

    const params = new URLSearchParams(window.location.search);
    const selectedVariantID = params.get('variant');

    if (!selectedVariantID) {
      return;
    }

    const variant = data.variants.find((variant) => variant.id === parseInt(selectedVariantID, 10));

    if (!variant) {
      return;
    }

    // If selected variant matches value and index of node
    if (variant.options[parseInt(NonNullish(index), 10)] !== value) {
      return;
    }

    node.classList.toggle(classes.available, variant.available);
    getAllRelatedVariants.forEach((variant) => updateOption(variant));
  };

  onMounted(() => {
    init();
  });

  node.addEventListener('click', () => {
    dispatchEvent('option:select', { index, value });
    getAllRelatedVariants.forEach((variant) => updateOption(variant));
  });
});
